<template>
  <main>
    <section v-for="(item, index) in list" :key="index">
      <img :src="item.image_url">
      <span>{{item.item_dict_name}}</span>
      <router-link class="btn" :to="{path: '/recuperate', query: {code: item.system_code, title: item.item_dict_name, ...routeQuery}}">{{ $t('actions.view') }}</router-link>
    </section>
  </main>
</template>

<script>
  import {getReportConditioningList} from "../net/api";
  import { routeLanguageMixin } from "@/utils/routeLanguageHelper";

  export default {
    name: "Scheme",
    mixins: [routeLanguageMixin],
    components: {},

    data() {
      return {
        list: []
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        getReportConditioningList({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.list = data.list;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  section {
    height: 120px;
    background: #D8E8FF;
    border-radius: 20px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    img {
      width: 80px;
      height: 80px;
      display: block;
    }

    span {
      color: #333333;
      display: block;
      flex: 1;
      padding-left: 10px;
    }

    .btn {
      display: flex;
      text-decoration: none;
      width: 140px;
      height: 50px;
      background: #FFFFFF;
      border-radius: 10px;
      font-size: 26px;
      color: #333333;
      align-items: center;
      justify-content: center;
    }
  }
</style>